import component from './imgCarousel.component';
import './imgCarousel.scss';

let module = angular.module('imgCarousel', [])
.component('imgCarousel', component)
.name;

export default module;


// WEBPACK FOOTER //
// ./app/components/imgCarousel/imgCarousel.js